<template>
  <div>
    <!-- 导航（鸣野跟进与留学跟进共用本页，根据路由区分面包屑） -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="isMingyeFollow">
        <router-link to="/mingye">鸣野资源</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-else>
        <router-link to="./common">学生跟进</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ isMingyeFollow ? '鸣野资源跟进' : '跟进详情' }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索" prop="key">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={};">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>跟进列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
        <el-table-column prop="stuName" label="姓名"></el-table-column>
          <el-table-column prop="summary" label="目前状况"></el-table-column>
          <el-table-column prop="stuState" label="跟进阶段"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.state==1">{{scope.row.stateName}}</el-tag>
              <el-tag type="primary" v-else-if="scope.row.state==2">{{scope.row.stateName}}</el-tag>
              <el-tag type="success" v-else>{{scope.row.stateName}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="nextDate" label="下次回访时间"></el-table-column>
          <el-table-column prop="nextSubject" label="下次回访主题"></el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id>0?'编辑跟进详情':'添加跟进详情'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item label="目前状况" prop="summary" :rules="[{required:true,message:'请输入目前状况'}]">
          <el-input v-model="form.summary" placeholder="请输入目前状况"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="跟进阶段" prop="stuState" :rules="[{required:true,message:'请输入跟进阶段'}]">
              <el-select v-model="form.stuState" placeholder="请选择跟进阶段" filterable>
                <el-option
                  v-for="item in stustatelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="回访时间" prop="nextDate">
          <el-date-picker
            v-model="form.nextDate"
            value-format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择下次回访时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="回访主题" prop="nextSubject">
          <el-input v-model="form.nextSubject" placeholder="请输入下次回访主题"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      stuid: 0,
      key: "",
      state: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      roleVisible: false,
      treeData: [],
      checkedKeys: [],
      stustatelist: [
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" }
      ] //跟进状态
    };
  },
  computed: {
    isMingyeFollow() {
      return this.$route.name === "mingyefollow";
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      params.stuid = _this.stuid;
      params.isMingye = this.isMingyeFollow;
      $.get(url.getStu("getlist_follow"), params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var info = { ...this.form, stuid: this.stuid, isMingye: this.isMingyeFollow };
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          $.post(url.getStu("addorupdate_follow"), info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function(row) {
      var _this = this;
      var link = url.getStu("delete_follow");
      var id = row.id;

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { idList: id }, res => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    var _this = this;
    //接收参数id
    _this.stuid = this.$route.query.id;
    if (_this.stuid > 0) {
      _this.getList();
    } else {
      _this.form = {};
    }
  }
};
</script>

